<template>
  <v-dialog
    v-model="internal"
    persistent
    width="700"
  >
    <v-card>
      <!-- HEADER -->
      <v-card-actions class="d-flex justify-space-between">
        <v-card-title>
          {{$t('broker.labels.selectClientOperation')}}
        </v-card-title>

        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-actions>

      <!-- BODY -->
      <v-card-text class="py-0">
        <div  style="width: 100%;" class="d-flex">
        <div class="d-flex flex-gap-2 flex-column my-2 mx-3 py-0 flex-grow-1">
          <v-card-subtitle class="my-2">{{$t('broker.labels.selectClient')}}</v-card-subtitle>
          <v-select
              :items="clients"
              item-text="companyName"
              item-value="id"
              v-model="selectedClientId"
              data-testid="operation-client"
              outlined
              dense
          />
        </div>
        <!--volume-->
          <!-- <div class="d-flex flex-gap-2 flex-column my-2 mx-3 py-0 flex-grow-1">
              <v-card-subtitle class="my-2">{{$t('broker.labels.volumeBrl')}}</v-card-subtitle>
              <v-text-field
                  v-model="volume"
                  v-money="money"
                  outlined
                  dense
              />
          </div> -->
        </div>

        <div  class="d-flex flex-gap-2 flex-column mx-3 py-0">
          <!--remessa type-->
          <v-card-subtitle class="my-2">{{$t('broker.labels.transactionPurpose')}}</v-card-subtitle>
              <v-select
                  v-model="operationType"
                  data-testid="operation-purpose"
                  :items="list"
                  item-text="text"
                  item-value="value"
                  outlined
                  dense
                />
        </div>
      </v-card-text>

      <!-- FOOTER -->
      <v-card-actions class="d-flex justify-end">
        <v-btn
          color="primary"
          class="ma-2"
          data-testid="operation-details-next"
          @click="nextStep"
          :disabled="selectedClientId === null || !operationType"
        >
          Next
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { useExecutionStore } from '@/store';
import { mapStores } from 'pinia';

export default {
  name: "SelectedClientDialog",
  props: {
    clients: {type: Array, default: () => []},
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
        selectedClientId: null,
        client: null,
        operationType: null,
        volume: null,
        money: {
      decimal: ",",
      thousands: ".",
      prefix: "R$ ",
      precision: 2,
      masked: false,
    },
       
    }
  },
  computed: {
    ...mapStores(useExecutionStore),
    internal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit("input", val)
      }
    },
    list(){
      const operationTypes = this.$t('broker.operationTypes')
      return Object.entries(operationTypes).map(([key,label])=> ({text: label, value : key}))
    }
  },
  methods: {
    closeDialog() {
      this.$emit("input", false)
      this.client = null
      this.operationType = null
      this.selectedClientId = null
      this.volume = 0
    },

    nextStep() {
      const finalVol = this.executionStore.convertOperationVolumeToNumber(this.volume)

      const payload = {
        client: this.selectedClientId,
        remessa: this.operationType,
      }
      this.$emit("input", false)
      this.$emit('operation-details-submitted', payload)
      this.client = null
      this.selectedClientId = null
      this.operationType = null
      this.volume = 0
    }
  }
}
</script>
<style scoped>
::v-deep .v-input--radio-group__input{
  display: flex;
  flex-direction: row !important;
  flex-wrap: wrap;
  align-items: center !important;
  gap: 1.5rem .5rem;
  margin: 1rem;
}
</style>
